import {
  Component,
  EventEmitter,
  Input,
  Output,
  effect,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { WHTeamDOM } from '@workheld/workheld-shared-lib';
import { UIStore } from 'src/app/app-services/ui-service.v2';
import { map } from 'rxjs/operators';
@Component({
  selector: 'app-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.scss'],
  standalone: false,
})
export class TeamListComponent {
  @Output() teamSelected = new EventEmitter<WHTeamDOM>();
  @Output() teamRemoved = new EventEmitter<boolean>();
  @Input() canRemoveFilter = false;
  @Input('selectedTeam') set _selectedTeam(team: WHTeamDOM) {
    this.selectedTeamDOM = team;
  }
  @Input('teamList') set _teamList(list: WHTeamDOM[]) {
    this.filteredTeamList = list;
    this.teamList = list;
  }
  uiStore = inject(UIStore);
  route = inject(ActivatedRoute);
  teamIdParam = toSignal(
    this.route.queryParamMap.pipe(map((params) => params.get('teamId'))),
    {
      initialValue: this.route.snapshot.queryParamMap.get('teamId'),
    },
  );
  selectedTeamDOM = null;
  teamList: WHTeamDOM[] = [];
  filteredTeamList: WHTeamDOM[] = [];

  onSelect(team: WHTeamDOM) {
    this.selectedTeamDOM = team;
    this.teamSelected.emit(team);
  }

  onRemove() {
    if (!this.canRemoveFilter) {
      return;
    }

    this.teamRemoved.emit(true);
    this.selectedTeamDOM = null;
  }

  onSearchTerm(term: string) {
    if (term) {
      this.filteredTeamList = this.teamList.filter((team) => {
        return team.name.toLowerCase().includes(term.toLowerCase());
      });
    } else {
      this.filteredTeamList = this.teamList;
    }
  }

  constructor() {
    effect(() => {
      const teamId = this.teamIdParam();
      if (this.uiStore.teams()?.size === 0) {
        return;
      }

      if (!teamId) {
        return;
      }

      const team = this.uiStore.getTeamById(teamId);
      if (team && this.selectedTeamDOM?.id !== team.id) {
        this.selectedTeamDOM = team;
        this.teamSelected.emit(team);
      }
    });
  }
}
